// extracted by mini-css-extract-plugin
export var categoryHeader = "g1_pK";